import { render, staticRenderFns } from "./SLItemInvoice.vue?vue&type=template&id=04372b56&"
import script from "./SLItemInvoice.vue?vue&type=script&lang=js&"
export * from "./SLItemInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports